module.exports = __webpack_public_path__ + "img/beneficio-bem-estar.c54f8f6d.svg";